const JsonViewer = {
    settings: {
        rootCollapsed: true,
    },
    init: function () {
        $('[data-json]').each(function () {
            let element = $(this);
            let val = element.attr('data-json');
            try {
                element.jsonViewer(JSON.parse(val), {
                    collapsed: false,
                    rootCollapsable: true,
                    withLinks: false
                });
                if (JsonViewer.settings.rootCollapsed === true) {
                    element.children('.json-toggle').click();
                }
            } catch (error) {
                console.error(error)
            }
        });
    }
};

$(document).ajaxComplete(function (event, xhr) {
      if (
        Object.prototype.hasOwnProperty.call(xhr, 'responseText')
        && typeof xhr.responseText === 'string'
        && xhr.responseText.includes('_datagrid')
      ) {
          JsonViewer.init();
      }
  }
);

$(function() {
    JsonViewer.init();
});
